import { OktaAuth } from "@okta/okta-auth-js";
import { RemoveAdminLocalStore, RemoveAllLocalStore, LocalStore, GetLocalStore } from "../utils/storage";
import { useOktaAuth } from "@okta/okta-react";
import { stringify } from "query-string";

const redirect_uri = `${process.env.REACT_APP_URL}/auth`;
const response_type = "id_token token";
const scope = "openid profile";
const logout = true;


export const oktaAuth = new OktaAuth({
  issuer: process.env.REACT_APP_OKTA_ISSUER,
  clientId: process.env.REACT_APP_OKTA_CLIENT_ID,
  redirectUri: `${window.location.origin}/login/callback`,
  pkce: true,
  scopes: ["openid", "profile", "email"],
  tokenManager: {
    storage: "localStorage",
    autoRenew: true,
    expireEarlySeconds: 60,
  },
});

export const oktaLoginAuth = async () => {
  await oktaAuth.signInWithRedirect();
};

export const handleAuthCallback = async () => {
  try {
    const { tokens } = await oktaAuth.token.parseFromUrl();
    if (tokens.idToken && tokens.accessToken) {
      await oktaAuth.tokenManager.add("idToken", tokens.idToken);
      await oktaAuth.tokenManager.add("accessToken", tokens.accessToken);
      const authUrl = `/auth?#id_token=${tokens.idToken.idToken}&access_token=${tokens.accessToken.accessToken}`;
      window.location.assign(authUrl);
    } else {
      console.error("Token retrieval failed!");
      oktaLoginAuth();
    }
  } catch (error) {
    console.error("Error handling Okta callback:", error);
    oktaLoginAuth();
  }
};

export const useAuthLogout = () => {
  const { authState, oktaAuth } = useOktaAuth();

  const logout = async () => {
    if (authState?.idToken?.issuer === process.env.REACT_APP_OKTA_ISSUER) {
      return oktaSignout();
    }
  };
  return logout;
};

export const oktaSignout = async () => {
  try {
    const idTokenObject = await oktaAuth.tokenManager.get("idToken");
    const idToken = idTokenObject?.idToken;
    if (!idToken) {
      console.error("No ID Token available! Logging out without token hint.");
    }
    const oktaDomain = process.env.REACT_APP_OKTA_DOMAIN;
    const logoutRedirectUri = encodeURIComponent(window.location.origin + "/signout");
    const oktaLogoutUrl = `${oktaDomain}/oauth2/v1/logout?id_token_hint=${idToken}&post_logout_redirect_uri=${logoutRedirectUri}`;
    await oktaAuth.tokenManager.clear();
    RemoveAllLocalStore();
    RemoveAdminLocalStore();
    window.location.href = oktaLogoutUrl;
  } catch (error) {
    console.error("Logout error:", error);
  }
};